export default __webpack_public_path__ + "static/media/Allan Benatti_.0c4581ca.png";